module.exports = __webpack_public_path__ + "109ab3993f0d7ef73ea665fe74e0fd60.svg";